import { useQuery } from 'react-query';
import { HTTPError, Site } from 'types';
import { getQueryAsync } from 'api/api-client';
import { useAppContext } from 'context/app/app-context';

const getSites = async (tenantId: string): Promise<Site[]> => {
    return getQueryAsync<Site[]>(`/Sites?Filter=tenant eq '${tenantId}'&Sort=name`);
};

export default function useSites() {
    const {
        state: { tenant }
    } = useAppContext();

    return useQuery<Site[], HTTPError>(
        ['Sites', tenant.id], 
        () => getSites(tenant.id), 
        { enabled: Boolean(tenant.id) }
    );
}